import React, { useState } from 'react';
import { Lock, ChevronDown, ChevronUp, BookOpen } from 'lucide-react';
const TIERS = [{
  id: 'geografia',
  emoji: '⚡',
  name: 'GEOGRAFÍA LISTA',
  description: '6 tomos de Geografía + 3 bonos de regalo',
  oldPrice: '$49.990',
  price: '$19.990',
  badges: [],
  checkoutUrl: 'https://checkout.kitonline.shop/cart/47280783327470:1'
}, {
  id: 'completo',
  emoji: '🏆',
  name: 'KIT COMPLETO',
  description: 'KIT COMPLETO GEOGRAFÍA + PACK DE MAPAS + PACK CICLO ORIENTADO',
  oldPrice: '$99.990',
  price: '$29.990',
  badges: [{
    text: 'Más elegido',
    color: 'bg-[#16a34a] text-white'
  }, {
    text: 'AHORRÁS $9.990',
    color: 'bg-[#fbbf24]/20 text-[#fbbf24]'
  }],
  checkoutUrl: 'https://checkout.kitonline.shop/cart/47547120812270:1'
}];
const CICLO_ORIENTADO = [{
  title: 'TOMO 7 — Argentina en el Mundo y Globalización',
  emoji: '📕',
  units: [{
    name: 'Unidad 1: Globalización y territorio',
    topics: ['Concepto de globalización', 'Transformaciones del espacio geográfico', 'Escalas global, regional y local']
  }, {
    name: 'Unidad 2: Argentina en el sistema mundial',
    topics: ['Inserción económica internacional', 'Exportaciones e importaciones', 'Relación con mercados globales']
  }, {
    name: 'Unidad 3: Bloques regionales',
    topics: ['Mercosur', 'Integración regional', 'Ventajas y desafíos']
  }, {
    name: 'Unidad 4: Redes globales',
    topics: ['Transporte internacional', 'Flujos de información', 'Conectividad']
  }, {
    name: 'Unidad 5: Impacto de la globalización',
    topics: ['Cambios en la economía argentina', 'Desigualdades', 'Dependencia económica']
  }],
  includes: ['Análisis de casos reales', 'Actividades de interpretación de datos', 'Evaluación completa']
}, {
  title: 'TOMO 8 — Desigualdades Territoriales',
  emoji: '📗',
  units: [{
    name: 'Unidad 1: Concepto de desigualdad territorial',
    topics: ['Centro vs periferia', 'Desarrollo desigual']
  }, {
    name: 'Unidad 2: Desigualdades en Argentina',
    topics: ['Regiones más y menos desarrolladas', 'Indicadores socioeconómicos']
  }, {
    name: 'Unidad 3: Acceso a recursos',
    topics: ['Educación', 'Salud', 'Servicios básicos']
  }, {
    name: 'Unidad 4: Pobreza y exclusión',
    topics: ['Factores estructurales', 'Consecuencias sociales']
  }, {
    name: 'Unidad 5: Políticas y soluciones',
    topics: ['Intervención del Estado', 'Desarrollo regional', 'Inclusión social']
  }],
  includes: ['Análisis de estadísticas', 'Actividades críticas', 'Evaluación con rúbricas']
}, {
  title: 'TOMO 9 — Geografía Ambiental Avanzada',
  emoji: '📘',
  units: [{
    name: 'Unidad 1: Ambiente y sociedad',
    topics: ['Relación sociedad-naturaleza', 'Impacto humano']
  }, {
    name: 'Unidad 2: Cambio climático',
    topics: ['Causas', 'Consecuencias en Argentina', 'Escenarios futuros']
  }, {
    name: 'Unidad 3: Problemáticas ambientales',
    topics: ['Deforestación', 'Contaminación', 'Minería']
  }, {
    name: 'Unidad 4: Crisis de recursos',
    topics: ['Agua', 'Energía', 'Suelo']
  }, {
    name: 'Unidad 5: Desarrollo sustentable',
    topics: ['Concepto', 'Estrategias', 'Modelos de desarrollo']
  }],
  includes: ['Estudios de caso', 'Actividades de análisis', 'Evaluación aplicada']
}, {
  title: 'TOMO 10 — Geografía Aplicada y Análisis Espacial',
  emoji: '📙',
  units: [{
    name: 'Unidad 1: Lectura del espacio geográfico',
    topics: ['Interpretación de mapas', 'Escalas']
  }, {
    name: 'Unidad 2: Análisis de datos',
    topics: ['Gráficos', 'Estadísticas', 'Indicadores']
  }, {
    name: 'Unidad 3: Herramientas geográficas',
    topics: ['SIG (introducción)', 'Uso de mapas digitales']
  }, {
    name: 'Unidad 4: Investigación geográfica',
    topics: ['Planteo de problemas', 'Recolección de información', 'Análisis']
  }, {
    name: 'Unidad 5: Proyecto final integrador',
    topics: ['Desarrollo completo paso a paso', 'Análisis territorial', 'Presentación de resultados']
  }],
  includes: ['Actividades prácticas', 'Ejercicios aplicados', 'Evaluación final']
}];
function CicloOrientadoAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="space-y-2 sm:space-y-3" data-id="element-117">
      {CICLO_ORIENTADO.map((tomo, index) => {
      const isOpen = openIndex === index;
      return <div key={index} onClick={() => setOpenIndex(isOpen ? null : index)} className={`bg-[#1a1a1a] border rounded-xl overflow-hidden transition-all duration-300 cursor-pointer ${isOpen ? 'border-[#16a34a] ring-1 ring-[#16a34a]/20' : 'border-gray-800 hover:border-gray-600'}`} data-id="element-118">
            <div className="p-3 sm:p-4" data-id="element-119">
              <div className="flex items-center justify-between" data-id="element-120">
                <h4 className="text-xs sm:text-sm font-bold text-white flex items-center gap-1.5" data-id="element-121">
                  <span data-id="element-122">{tomo.emoji}</span> {tomo.title}
                </h4>
                <div className="text-gray-500 ml-2" data-id="element-123">
                  {isOpen ? <ChevronUp size={16} data-id="element-124" /> : <ChevronDown size={16} data-id="element-125" />}
                </div>
              </div>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[600px] opacity-100 mt-3' : 'max-h-0 opacity-0'}`} data-id="element-126">
                <div className="h-px bg-gray-800 mb-3" data-id="element-127"></div>
                <div className="space-y-2.5" data-id="element-128">
                  {tomo.units.map((unit, uidx) => <div key={uidx} data-id="element-129">
                      <p className="text-[11px] sm:text-xs font-bold text-gray-300 mb-0.5" data-id="element-130">
                        {unit.name}
                      </p>
                      <ul className="space-y-0.5 ml-2.5" data-id="element-131">
                        {unit.topics.map((topic, tidx) => <li key={tidx} className="text-[10px] sm:text-xs text-gray-500 flex items-start" data-id="element-132">
                            <span className="text-[#16a34a] mr-1.5" data-id="element-133">•</span>
                            {topic}
                          </li>)}
                      </ul>
                    </div>)}
                </div>
                <div className="mt-2.5 pt-2.5 border-t border-gray-800" data-id="element-134">
                  <p className="text-[10px] sm:text-xs font-bold text-[#16a34a] mb-1 flex items-center gap-1" data-id="element-135">
                    <BookOpen className="w-3 h-3" data-id="element-136" /> Incluye:
                  </p>
                  <ul className="space-y-0.5 ml-2.5" data-id="element-137">
                    {tomo.includes.map((item, iidx) => <li key={iidx} className="text-[10px] sm:text-xs text-gray-500 flex items-start" data-id="element-138">
                        <span className="text-[#16a34a] mr-1.5" data-id="element-139">✓</span>
                        {item}
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>
          </div>;
    })}
    </div>;
}
export function PricingCards({
  showExtras = true
}: {
  showExtras?: boolean;
}) {
  const [selected, setSelected] = useState('completo');
  const selectedTier = TIERS.find(t => t.id === selected)!;
  return <div className="space-y-3 sm:space-y-4 max-w-lg mx-auto" data-id="element-140">
      {TIERS.map(tier => {
      const isSelected = selected === tier.id;
      return <div key={tier.id} onClick={() => setSelected(tier.id)} className={`bg-[#141414] rounded-xl p-4 sm:p-5 cursor-pointer transition-all duration-200 ${isSelected ? 'border-2 border-[#16a34a] shadow-[0_0_15px_rgba(22,163,74,0.15)]' : 'border border-gray-800 hover:border-gray-600'}`} data-id="element-141">
            <div className="flex items-center gap-3" data-id="element-142">
              {/* Radio button */}
              <div className={`flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-[#16a34a]' : 'border-gray-600'}`} data-id="element-143">
                {isSelected && <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-[#16a34a]" data-id="element-144"></div>}
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0" data-id="element-145">
                <div className="flex items-center gap-2 mb-0.5" data-id="element-146">
                  <span className="text-base sm:text-lg" data-id="element-147">{tier.emoji}</span>
                  <h3 className="text-sm sm:text-lg font-black text-white uppercase" data-id="element-148">
                    {tier.name}
                  </h3>
                </div>
                {tier.badges.length > 0 && <div className="flex items-center gap-1.5 mb-0.5" data-id="element-149">
                    {tier.badges.map((badge, bi) => <span key={bi} className={`${badge.color} text-[8px] sm:text-[10px] font-bold px-1.5 py-0.5 rounded-full uppercase`} data-id="element-150">
                        {badge.text}
                      </span>)}
                  </div>}
                <p className="text-gray-400 text-[10px] sm:text-xs" data-id="element-151">
                  {tier.description}
                </p>
              </div>

              {/* Price */}
              <div className="text-right flex-shrink-0 ml-2" data-id="element-152">
                <p className="text-gray-500 text-[10px] sm:text-xs line-through" data-id="element-153">
                  {tier.oldPrice}
                </p>
                <p className="text-white text-xl sm:text-3xl font-black" data-id="element-154">
                  {tier.price}
                </p>
              </div>
            </div>
          </div>;
    })}

      {/* CTA Button */}
      <a href={selectedTier.checkoutUrl} className="block w-full bg-[#16a34a] hover:bg-green-700 text-white text-base sm:text-xl font-black py-4 sm:py-5 px-4 rounded-xl shadow-[0_4px_20px_rgba(22,163,74,0.4)] hover:translate-y-[2px] transition-all uppercase text-center" data-id="element-155">
        SÍ, QUIERO{' '}
        {selectedTier.id === 'completo' ? 'PACK COMPLETO' : 'GEOGRAFÍA LISTA'} →
      </a>

      {/* Trust */}
      <div className="flex items-center justify-center text-gray-500 text-[10px] sm:text-xs font-medium" data-id="element-156">
        <Lock className="h-3 w-3 mr-1" data-id="element-157" />
        PAGO SEGURO CON MERCADO PAGO
      </div>

      {/* What's included */}
      <div className="bg-[#141414] rounded-xl border border-gray-800 p-4 sm:p-6 mt-2" data-id="element-158">
        <h4 className="text-sm sm:text-base font-black text-white text-center mb-3 sm:mb-4" data-id="element-159">
          🎯 ¿QUÉ INCLUYE ESTE PACK?
        </h4>
        <div className="space-y-2 sm:space-y-2.5" data-id="element-160">
          <div className="flex items-start gap-2" data-id="element-161">
            <span className="text-[#16a34a] text-sm font-bold mt-0.5" data-id="element-162">✔</span>
            <p className="text-gray-300 text-xs sm:text-sm" data-id="element-163">
              Kit Completo Geografía Argentina Lista 2026 (Tomo 1 al 6)
            </p>
          </div>
          <div className="flex items-start gap-2" data-id="element-164">
            <span className="text-[#16a34a] text-sm font-bold mt-0.5" data-id="element-165">✔</span>
            <p className="text-gray-300 text-xs sm:text-sm" data-id="element-166">
              🎁 Bonus exclusivos
            </p>
          </div>
          <div className="flex items-start gap-2" data-id="element-167">
            <span className="text-[#16a34a] text-sm font-bold mt-0.5" data-id="element-168">✔</span>
            <p className="text-gray-300 text-xs sm:text-sm" data-id="element-169">
              🗺️ Pack de Mapas Didácticos
            </p>
          </div>
          <div className="flex items-start gap-2" data-id="element-170">
            <span className="text-[#16a34a] text-sm font-bold mt-0.5" data-id="element-171">✔</span>
            <p className="text-gray-300 text-xs sm:text-sm" data-id="element-172">
              🚀 Pack Ciclo Orientado (Tomo 7 al 10)
            </p>
          </div>
        </div>
      </div>

      {/* Ciclo Orientado Index — only in main pricing */}
      {showExtras && <>
          <div className="mt-2" data-id="element-173">
            <h4 className="text-xs sm:text-sm font-bold text-[#fbbf24] text-center mb-3" data-id="element-174">
              📚 ÍNDICE — CICLO ORIENTADO (TOMO 7 AL 10)
            </h4>
            <CicloOrientadoAccordion data-id="element-175" />
          </div>

          {/* Standalone Ciclo Orientado purchase */}
          <div className="mt-4 bg-[#141414] rounded-xl border border-gray-800 p-4 sm:p-5" data-id="element-176">
            <div className="flex items-center justify-between" data-id="element-177">
              <div className="flex-1" data-id="element-178">
                <div className="flex items-center gap-2 mb-1" data-id="element-179">
                  <span className="text-base sm:text-lg" data-id="element-180">🚀</span>
                  <h3 className="text-sm sm:text-lg font-black text-white uppercase" data-id="element-181">
                    KIT GEOGRAFÍA CICLO ORIENTADO
                  </h3>
                </div>
                <p className="text-gray-400 text-[10px] sm:text-xs" data-id="element-182">
                  7 tomos completos + bonus principales
                </p>
              </div>
              <div className="text-right flex-shrink-0 ml-4" data-id="element-183">
                <p className="text-white text-xl sm:text-3xl font-black" data-id="element-184">
                  $17.990
                </p>
              </div>
            </div>
            <a href="https://checkout.kitonline.shop/cart/47799116366062:1" className="block w-full bg-[#16a34a] hover:bg-green-700 text-white text-sm sm:text-base font-black py-3 sm:py-4 px-4 rounded-xl shadow-[0_4px_20px_rgba(22,163,74,0.4)] hover:translate-y-[2px] transition-all uppercase text-center mt-3" data-id="element-185">
              QUIERO CICLO ORIENTADO →
            </a>
          </div>
        </>}
    </div>;
}
export function PricingSection() {
  return <section id="oferta" className="py-8 sm:py-16 bg-[#0a0a0a] relative" data-id="element-186">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-187">
        <div className="text-center mb-6 sm:mb-8" data-id="element-188">
          <h2 className="text-xl sm:text-4xl md:text-5xl font-black text-white uppercase tracking-tight" data-id="element-189">
            Oferta Especial
          </h2>
          <div className="h-0.5 sm:h-1 w-16 sm:w-20 bg-[#16a34a] mx-auto mt-2 sm:mt-3 rounded-full" data-id="element-190"></div>
        </div>

        <PricingCards data-id="element-191" />

        {/* ACTIVITIES GALLERY */}
        <div className="mt-8 sm:mt-12 bg-[#141414] rounded-xl border border-gray-800 overflow-hidden" data-id="element-192">
          <div className="bg-[#16a34a]/10 border-b border-[#16a34a]/20 py-3 sm:py-4 px-4 sm:px-6 text-center" data-id="element-193">
            <h3 className="text-sm sm:text-xl font-bold text-[#16a34a]" data-id="element-194">
              📚 Estas son algunas de las actividades que encontrarás en el kit
              completo de geografía
            </h3>
          </div>
          <div className="p-3 sm:p-6" data-id="element-195">
            <div className="grid grid-cols-2 gap-2 sm:gap-4" data-id="element-196">
              <a href="#oferta" className="block rounded-lg overflow-hidden border border-gray-700 hover:border-[#16a34a] transition-colors shadow-md" data-id="element-197">
                <img src="https://cdn.magicpatterns.com/uploads/gmoXZRox9B788jnq5uDASt/Captura_de_pantalla_2025-12-15_205604.png" alt="Actividad de Geografía - Integraciones económicas" className="w-full h-auto" data-id="element-198" />
              </a>
              <a href="#oferta" className="block rounded-lg overflow-hidden border border-gray-700 hover:border-[#16a34a] transition-colors shadow-md" data-id="element-199">
                <img src="https://cdn.magicpatterns.com/uploads/7n3mVUMv1k2zZ5PRvSfSQx/Captura_de_pantalla_2025-12-15_205410.png" alt="Actividad de Geografía - Organización del espacio mundial" className="w-full h-auto" data-id="element-200" />
              </a>
              <a href="#oferta" className="block rounded-lg overflow-hidden border border-gray-700 hover:border-[#16a34a] transition-colors shadow-md" data-id="element-201">
                <img src="https://cdn.magicpatterns.com/uploads/oVHcwjx1pWdRcxeQvhndA7/Captura_de_pantalla_2025-12-15_205455.png" alt="Actividad de Geografía - América nuestro continente" className="w-full h-auto" data-id="element-202" />
              </a>
              <a href="#oferta" className="block rounded-lg overflow-hidden border border-gray-700 hover:border-[#16a34a] transition-colors shadow-md" data-id="element-203">
                <img src="https://cdn.magicpatterns.com/uploads/qbPZTJRDq9FqTjxQBPaQRB/Captura_de_pantalla_2025-12-15_205536.png" alt="Actividad de Geografía - División política siglo XX" className="w-full h-auto" data-id="element-204" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}